import React from "react";
export const Bell: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		<g transform="translate(-387.000000, -2574.000000)">
			<g transform="translate(102.500000, 2052.500000)">
				<g transform="translate(284.500000, 519.500000)">
					<g
						id="Atoms/Icons/24px/Alert/notifications"
						transform="translate(0.000000, 2.000000)"
					>
						<path
							d="M0,0 L24,0 L24,24 L0,24 L0,0 Z"
							id="Path"
							strokeOpacity="0.01"
							stroke="#000000"
							strokeWidth="0.01"
						></path>
						<path
							d="M17,16 L15.8685171,14.3027756 L15.8685171,8.9999433 C15.8685171,7.34910117 14.5181602,6 12.8587541,6 L10.8782801,6 C9.21090648,6 7.86851709,7.34081867 7.86851709,8.9999433 L7.86851709,14.3027756 L6.73703418,16 L17,16 Z M17.8685171,13.6972244 L20.7370342,18 L3,18 L5.86851709,13.6972244 L5.86851709,8.9999433 C5.86851709,6.23572465 8.10686081,4 10.8782801,4 L12.8587541,4 C15.6223134,4 17.8685171,6.24411492 17.8685171,8.9999433 L17.8685171,13.6972244 Z M10.8685171,18 L10.8685171,19 C10.8685171,19.5522847 11.3123819,20 11.8685171,20 C12.4208018,20 12.8685171,19.5561352 12.8685171,19 L12.8685171,18 L10.8685171,18 Z M8.86851709,19 L8.86851709,18 L14.8685171,18 L14.8685171,19 C14.8685171,20.660569 13.5255141,22 11.8685171,22 C10.2079481,22 8.86851709,20.656997 8.86851709,19 Z"
							fill="#E1AA1E"
						></path>
					</g>
				</g>
			</g>
		</g>
	</g>
);
